import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";

const ChartDoughnut = ({ data }) => {
  const [chartOptions, setChartOptions] = useState({});
  const [chartSeries, setChartSeries] = useState([]);

  useEffect(() => {
    const chartLabels = data.map((item) => item.nome);
    const chartDataValues = data.map((item) => item.valor);

    // Cores mais escuras e representativas da área da saúde
    const chartColors = [
      "#6ABCEB", // Azul mais escuro
      "#5AA58E", // Verde escuro
      "#FFC107", // Dourado mais vibrante
      "#FF5252", // Vermelho mais intenso para atenção
      "#FFA726", // Laranja escuro
      "#80CBC4"  // Verde mais escuro
    ];

    // Configuração do gráfico Apex
    const chartOptions = {
      labels: chartLabels,
      colors: chartColors,
      legend: {
        position: 'bottom',
        labels: {
          colors: '#FFF', // Cor das labels na legenda
        },
      },
      tooltip: {
        y: {
          formatter: function (value) {
            const total = chartDataValues.reduce((acc, curr) => acc + curr, 0);
            const percentual = ((value / total) * 100).toFixed(2);
            return `${value} (${percentual}%)`;
          }
        }
      },
      plotOptions: {
        pie: {
          donut: {
            size: '65%', // Aumentar um pouco o espaço para o centro
            labels: {
              show: true,
              name: {
                show: true,
                fontSize: '18px',
                color: '#FFF',
                offsetY: -10,
              },
              value: {
                show: true,
                fontSize: '22px',
                color: '#FFF',
                fontWeight: 'bold',
                offsetY: 10,
                formatter: function (val) {
                  return val;
                }
              },
              total: {
                show: true,
                label: 'Total',
                color: '#FFF',
                fontSize: '20px',
                formatter: function (w) {
                  return w.globals.seriesTotals.reduce((a, b) => {
                    return a + b;
                  }, 0);
                }
              }
            }
          }
        }
      }
    };

    setChartOptions(chartOptions);
    setChartSeries(chartDataValues);
  }, [data]);

  return (
    <div className="flex justify-content-center">
      <ReactApexChart
        options={chartOptions}
        series={chartSeries}
        type="donut"
        width="380"
      />
    </div>
  );
};

export default ChartDoughnut;
